/* eslint @typescript-eslint/no-explicit-any: "off" */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import Interceptor from './Interceptor'

declare module 'axios' {
  export interface AxiosRequestConfig {
    convertRequestBodyToSnakeCase?: boolean
    convertResponseBodyToCamelCase?: boolean
    keysToAvoidConversion?: string[]
  }
}
class HttpService {
  axiosInstance: AxiosInstance
  interceptor: any
  defaultconvertRequestBodyToSnakeCase: boolean
  defaultConvertResponseBodyToCamelCase: boolean
  defaultKeysToAvoidConversion: string[]
  baseURL: string

  constructor(options: AxiosRequestConfig) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.baseURL = options.baseURL!
    this.defaultconvertRequestBodyToSnakeCase = true
    this.defaultConvertResponseBodyToCamelCase = true
    this.defaultKeysToAvoidConversion = []

    this.axiosInstance = axios.create({
      convertRequestBodyToSnakeCase: this.defaultconvertRequestBodyToSnakeCase,
      convertResponseBodyToCamelCase: this.defaultConvertResponseBodyToCamelCase,
      keysToAvoidConversion: this.defaultKeysToAvoidConversion,
      baseURL: options.baseURL,
      ...options,
    })
    this.interceptor = new Interceptor(this.axiosInstance)
  }

  async get(url: string, config?: AxiosRequestConfig) {
    const response: any = await this.axiosInstance.get(url, config)
    return response
  }

  async post(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig) {
    const response: any = await this.axiosInstance.post(url, payload, config)
    return response
  }

  async put(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig) {
    const response: any = await this.axiosInstance.put(url, payload, config)
    return response
  }

  async patch(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig) {
    const response: any = await this.axiosInstance.patch(url, payload, config)
    return response
  }

  async delete(url: string, config?: AxiosRequestConfig) {
    const response: any = await this.axiosInstance.delete(url, config)
    return response
  }
}

export default HttpService
